import type { WorkerQueuePeriod } from "@/api/adminJobTiming";
import type { DatasetUploadStatus } from "@/api/datasetUpload";
import {
  diagnosticJobKinds,
  diagnosticJobStatuses,
  type DiagnosticJobKind,
} from "@/api/adminDiagnosticJob";
import { parsePageParam } from "@/utils";

export const uploadJobStatuses = [
  "pending_upload",
  "uploaded",
  "fetching",
  "probing",
  "validating",
  "migrating",
  "publishing",
  "done",
  "failed",
  "duplicate_skipped",
  "conflict",
  "cancelled",
] as const satisfies readonly DatasetUploadStatus[];
export { diagnosticJobKinds, diagnosticJobStatuses };

export function readWorkerJobFilters<Status extends string>(
  params: URLSearchParams,
  statuses: readonly Status[],
) {
  const rawKind = params.get("kind");
  const kind: DiagnosticJobKind | undefined = diagnosticJobKinds.find((value) => value === rawKind);
  const status = statuses.filter((value) => params.getAll("status").includes(value));
  const rawPeriod = params.get("period");
  const period: WorkerQueuePeriod = rawPeriod === "7d" || rawPeriod === "all" ? rawPeriod : "24h";
  return { kind, status, period, page: parsePageParam(params.get("page")), size: 20 };
}
